import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import CustomTextInput from "../../../components/CustomTextInput";
import CustomSwitch from "../../../components/CustomSwitch";
import { ServiceService } from "../../../services/ServiceService";
import { YurticiCargoAgreementSchemeService } from "../../../services/YurticiCargoAgreementSchemeService";
import { AddYurticiCargoAgreementSchemeRequest } from "../../../models/request/yurticiCargoAgreementScheme/AddYurticiCargoAgreementSchemeRequest";
import { AddYurticiCargoAgreementSchemeResponse } from "../../../models/response/yurticiCargoAgreementScheme/AddYurticiCargoAgreementSchemeResponse";
import { GetYurticiCargoAgreementSchemeByIdResponse } from "../../../models/response/yurticiCargoAgreementScheme/GetYurticiCargoAgreementSchemeByIdResponse";
import { MultiplierTypeEnum } from "../../../models/common/Enums";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import { CompanyService } from "../../../services/CompanyService";

const YurticiCargoAgreementSchemeAdd = () => {
    const navigate = useNavigate();
    const pageName = "Kargo Modülü > Yurtiçi Kargo > Anlaşma Şablonu"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [yurticiCargoAgreementSchemeId, setYurticiCargoAgreementSchemeId] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [isIncome, setIsIncome] = useState(true);
    const [isOutcome, setIsOutcome] = useState(false);
    const [selectedMultiplier, setSelectedMultiplier] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedIntervalType, setSelectedIntervalType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedService, setSelectedService] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCustomer, setSelectedCustomer] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isComplete, setIsComplete] = useState(true);
    const [isScale, setIsScale] = useState(false);
    const [desc, setDesc] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [isDynamicService, setIsDynamicService] = useState(false);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetYurticiCargoAgreementSchemeByIdResponse = await YurticiCargoAgreementSchemeService.getYurticiCargoAgreementSchemeById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setYurticiCargoAgreementSchemeId(response.data.yurticiCargoAgreementSchemeId);
                setRefNo(response.data.refNo);
                setName(response.data.name);

                setIsIncome(response.data.isIncome);
                setIsOutcome(response.data.isOutcome);

                if (response.data.multiplierId && response.data.multiplierName)
                    setSelectedMultiplier({ label: response.data.multiplierName, value: response.data.multiplierId });

                if (response.data.intervalTypeId && response.data.intervalTypeName)
                    setSelectedIntervalType({ label: response.data.intervalTypeName, value: response.data.intervalTypeId });

                if (response.data.serviceId && response.data.serviceName)
                    setSelectedService({ label: response.data.serviceName, value: response.data.serviceId });

                if (response.data.customerId && response.data.customerName)
                    setSelectedCustomer({ label: response.data.customerName, value: response.data.customerId });

                if (response.data.currencyTypeId && response.data.currencyTypeName)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                setIsComplete(response.data.isComplete);
                setIsScale(response.data.isScale);
                setDesc(response.data.description);
                setIsCustomActive(response.data.isCustomActive);
                setIsDynamicService(response.data.isDynamicService);
            }
            else {
                var response2: GetConstantListResponse = await ConstantService.getConstantList('MULTIPLIER_TYPE', undefined, MultiplierTypeEnum.SIPARIS);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setSelectedMultiplier({ label: response2.data[0].value, value: response2.data[0].constantId });

                var response3: GetConstantListResponse = await ConstantService.getConstantList('CURRENCY', undefined, 'TRY');

                if (!response3.isSuccess) {
                    toast.error(response3.message)
                    return;
                }

                setSelectedCurrencyType({ label: response3.data[0].value, value: response3.data[0].constantId });
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveYurticiCargoAgreementScheme = async () => {
        try {
            if (Helpers.isEmpty(name))
                toast.error('Ad alanını doldurunuz!')
            else if (!isIncome && !isOutcome)
                toast.error('Gelir veya Gider alanını doldurunuz!')
            else if (!isComplete && !isScale)
                toast.error('Komple veya Baremli alanını doldurunuz!')
            else if (isComplete && !selectedMultiplier)
                toast.error('Çarpan alanını doldurunuz!')
            else if (isScale && !selectedIntervalType)
                toast.error('Aralık Türü alanını doldurunuz!')
            else if (!isDynamicService && !selectedService)
                toast.error('Hizmet Kalemi alanını doldurunuz!')
            else if (!selectedCurrencyType)
                toast.error('Döviz Cinsi alanını doldurunuz!')
            else if (Helpers.isEmpty(desc))
                toast.error('Açıklama alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var obj: AddYurticiCargoAgreementSchemeRequest = {
                    yurticiCargoAgreementSchemeId: yurticiCargoAgreementSchemeId,
                    currencyTypeId: selectedCurrencyType?.value,
                    description: desc,
                    intervalTypeId: selectedIntervalType?.value,
                    isComplete: isComplete,
                    isCustomActive: isCustomActive,
                    isDynamicService: isDynamicService,
                    isIncome: isIncome,
                    isOutcome: isOutcome,
                    isScale: isScale,
                    multiplierId: selectedMultiplier?.value,
                    name: name,
                    refNo: refNo,
                    serviceId: selectedService?.value,
                    customerId: selectedCustomer?.value,
                }

                var response: AddYurticiCargoAgreementSchemeResponse = await YurticiCargoAgreementSchemeService.addYurticiCargoAgreementScheme(obj);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomTextInput isLabelRequired labelText="Kod" value={refNo} setValue={setRefNo} isDisabled />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomTextInput isLabelRequired labelText="Ad" value={name} setValue={setName} />
                                    </div>

                                    <div className="col-md-4">
                                        <Box flexDirection={"row"}>
                                            <Box flex={1} justifyContent="center">
                                                <CustomSwitch
                                                    labelText="Gelir"
                                                    isLabelRequired
                                                    isActive={isIncome}
                                                    setIsActive={() => {
                                                        setIsIncome(!isIncome);
                                                        setIsOutcome(!isOutcome);
                                                        setSelectedService(undefined);
                                                    }}
                                                />
                                            </Box>
                                            <Box flex={1} justifyContent="center">
                                                <CustomSwitch
                                                    labelText="Gider"
                                                    isLabelRequired
                                                    isActive={isOutcome}
                                                    setIsActive={() => {
                                                        setIsIncome(!isIncome);
                                                        setIsOutcome(!isOutcome);
                                                        setSelectedService(undefined);
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-8">
                                        <CustomTextInput labelText="Açıklama" value={desc} setValue={setDesc} />
                                    </div>

                                    <div className="col-md-4">
                                        <Box flexDirection={"row"}>
                                            <Box flex={1} justifyContent="center">
                                                <CustomSwitch
                                                    labelText="Komple"
                                                    isLabelRequired
                                                    isActive={isComplete}
                                                    setIsActive={() => {
                                                        setIsComplete(!isComplete);
                                                        setIsScale(!isScale);
                                                        setSelectedMultiplier(undefined);
                                                        setSelectedIntervalType(undefined);
                                                    }}
                                                />
                                            </Box>
                                            <Box flex={1} justifyContent="center">
                                                <CustomSwitch
                                                    labelText="Baremli"
                                                    isLabelRequired
                                                    isActive={isScale}
                                                    setIsActive={() => {
                                                        setIsComplete(!isComplete);
                                                        setIsScale(!isScale);
                                                        setSelectedMultiplier(undefined);
                                                        setSelectedIntervalType(undefined);
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Çarpan"
                                            isLabelRequired
                                            selectedValue={selectedMultiplier}
                                            onChange={setSelectedMultiplier}
                                            onMenuOpen={() => ConstantService.getConstantList('MULTIPLIER_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                            disabled={!isComplete}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Aralık Türü"
                                            isLabelRequired
                                            selectedValue={selectedIntervalType}
                                            onChange={setSelectedIntervalType}
                                            onMenuOpen={() => ConstantService.getConstantList('INTERVAL_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                            disabled={!isScale}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <Box flexDirection={"row"}>
                                            <Box flex={1} justifyContent="center">
                                                <CustomSwitch
                                                    labelText="Dinamik Hizmet Kalemi"
                                                    isLabelRequired
                                                    isActive={isDynamicService}
                                                    setIsActive={() => {
                                                        setIsDynamicService(!isDynamicService);
                                                        setSelectedService(undefined);
                                                    }}
                                                />
                                            </Box>
                                            <Box flex={1} justifyContent="center">
                                                <CustomSwitch labelText="Aktif" isLabelRequired isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Hizmet Kalemi"
                                            isLabelRequired
                                            selectedValue={selectedService}
                                            onChange={setSelectedService}
                                            onMenuOpen={() => ServiceService.getServiceList(isIncome)}
                                            labelName='name'
                                            valueName='serviceId'
                                            additionalValue1Name={'incomePercentageName'}
                                            disabled={isDynamicService}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Döviz Cinsi"
                                            isLabelRequired
                                            selectedValue={selectedCurrencyType}
                                            onChange={setSelectedCurrencyType}
                                            onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Müşteri"
                                            selectedValue={selectedCustomer}
                                            onChange={setSelectedCustomer}
                                            onMenuOpen={[
                                                () => CompanyService.getCompanyList({ isCustomer: true })
                                            ]}
                                            labelName='name'
                                            valueName='companyId'
                                        />
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveYurticiCargoAgreementScheme}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment >
    )
}

export default YurticiCargoAgreementSchemeAdd;